import vue from "vue";
import VueRouter from "vue-router";

vue.use(VueRouter);

const routes = [
  {
    path: "/complete/:formId/:rowId",
    redirect: { name: "Complete" }
  },
  {
    path: "/:formId/:rowId/success",
    name: "Complete",
    component: () => import("./pages/Complete.vue")
  },
  {
    path: "/pages/:pageId/:rowId",
    component: () => import("./pages/Page.vue")
  },
  {
    path: "/:formId/:rowId",
    component: () => import("./pages/Form.vue")
  },
  {
    path: "/:formId/:rowId/static",
    component: () => import("./pages/Static.vue")
  },
  {
    path: "*",
    component: () => import("./pages/ErrorPage.vue")
  }
];

export default new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
});
